import React from 'react';
import bn from "../../../utils/bemnames";
import {getBreadcrumbs, IBreadcrumb} from '../../../utils/breadcrumbs';

const bem = bn.create('football-breadcrumbs');

const Breadcrumbs: React.FC = () => {
  return (
    <div className={bem.b()}>
      {getBreadcrumbs().length > 0 && (
        <div className={bem.e('list')}>
          {getBreadcrumbs().map((breadcrumb: IBreadcrumb, index: number) => {
            return (
              <React.Fragment key={index}>
                {getBreadcrumbs().length !== (index + 1) ? (
                  <div className={bem.e('list-item')}>
                    {breadcrumb.url ? <a className={bem.e('link')} href={breadcrumb.url}>{breadcrumb.text}</a> : <span className={bem.e('span')}>{breadcrumb.text}</span>}
                    <div className={bem.e('icon')}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" fill="none" viewBox="0 0 6 9">
                        <path fill="var(--siw-mc-main-theme-font-color)" d="m1.657.81-.944.94L3.78 4.81.713 7.87l.944.94 4.019-4-4.019-4Z"/>
                      </svg>
                    </div>
                  </div>
                ) : (
                  <div className={bem.e('list-item')}>
                    {breadcrumb.url ? <a className={`${bem.e('link')} ${bem.e('link--last')}`} href={breadcrumb.url}>{breadcrumb.text}</a> : <span className={`${bem.e('span')} ${bem.e('span--last')}`}>{breadcrumb.text}</span>}
                  </div>
                )}
              </React.Fragment>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default Breadcrumbs;
